(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article-figma"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.artfig').forEach(initArtfig);

    function slugify(text) {
      return text.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    }

    function initArtfig(root) {
      if (root.dataset.artfigInit) return;
      root.dataset.artfigInit = 'true';

      const prose = root.querySelector('[data-af-prose]');
      const toc = root.querySelector('[data-af-toc]');
      const tocList = root.querySelector('[data-af-toc-list]');
      const heads = prose ? [...prose.querySelectorAll('h2')] : [];

      if (prose && toc && tocList && heads.length > 1) {
        const links = [];
        heads.forEach((h, i) => {
          if (!h.id) h.id = slugify(h.textContent) || 'section-' + i;
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent;
          li.appendChild(a);
          tocList.appendChild(li);
          links.push(a);
        });
        toc.hidden = false;

        const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) {
            links.forEach((a) => a.classList.toggle('on', a.getAttribute('href') === '#' + entry.target.id));
          }
        }), { rootMargin: '-20% 0px -70% 0px' });
        heads.forEach((h) => io.observe(h));
      }

      const faqDetails = prose ? [...prose.querySelectorAll('.art-faq details')] : [];
      faqDetails.forEach((d, i) => { d.open = i === 0; });

      const copyBtn = root.querySelector('[data-af-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(window.location.href);
            copyBtn.setAttribute('aria-label', 'Link copied');
          } catch (err) {}
        });
      }

      const totop = root.querySelector('[data-af-totop]');
      const layout = root.querySelector('.af-layout');
      if (totop && layout) {
        const topIo = new IntersectionObserver(([entry]) => {
          totop.classList.toggle('on', !entry.isIntersecting);
        });
        topIo.observe(layout);
        totop.addEventListener('click', () => {
          window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      }

      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const revealIo = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('af-in');
          revealIo.unobserve(entry.target);
        }
      }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      if (reduceMotion) {
        root.querySelectorAll('.af-reveal').forEach((el) => el.classList.add('af-in'));
      } else {
        root.querySelectorAll('.af-reveal').forEach((el) => revealIo.observe(el));
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-figma"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.pcol').forEach(initPcol);

    function initPcol(root) {
      if (root.dataset.pcolInit) return;
      root.dataset.pcolInit = 'true';

      const filters = root.querySelector('[data-pcol-filters]');
      const scrim = root.querySelector('[data-pcol-scrim]');
      const openBtn = root.querySelector('[data-pcol-open-filters]');
      const closeBtns = root.querySelectorAll('[data-pcol-close-filters]');
      const clearBtns = root.querySelectorAll('[data-pcol-clear]');
      const sortSelect = root.querySelector('[data-pcol-sort]');
      const sortHidden = root.querySelector('[data-pcol-sort-hidden]');
      const form = filters ? filters.querySelector('form') : null;

      const openSheet = () => { filters.classList.add('is-open'); scrim.classList.add('on'); };
      const closeSheet = () => { filters.classList.remove('is-open'); scrim.classList.remove('on'); };

      if (openBtn) openBtn.addEventListener('click', openSheet);
      closeBtns.forEach((b) => b.addEventListener('click', closeSheet));
      if (scrim) scrim.addEventListener('click', closeSheet);

      clearBtns.forEach((b) => b.addEventListener('click', () => {
        window.location.href = root.dataset.sectionId ? window.location.pathname : window.location.pathname;
      }));

      if (sortSelect) {
        sortSelect.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortSelect.value);
          window.location.href = url.toString();
        });
      }

      const grid = root.querySelector('[data-pcol-grid]');
      const viewBtns = root.querySelectorAll('[data-pcol-cols]');
      viewBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const cols = btn.dataset.pcolCols;
          if (grid) grid.dataset.cols = cols;
          viewBtns.forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        });
      });

      root.addEventListener('click', (e) => {
        const heart = e.target.closest('[data-pf-wish]');
        if (!heart) return;
        const on = heart.getAttribute('aria-pressed') !== 'true';
        heart.setAttribute('aria-pressed', String(on));
      });

      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('pcol-in');
          io.unobserve(entry.target);
        }
      }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      const observeReveals = () => root.querySelectorAll('.pcol-reveal:not(.pcol-in)').forEach((el) => io.observe(el));
      if (reduceMotion) {
        root.querySelectorAll('.pcol-reveal').forEach((el) => el.classList.add('pcol-in'));
      } else {
        observeReveals();
      }

      const more = root.querySelector('[data-pcol-more]');
      if (more) {
        const loadBtn = more.querySelector('[data-pcol-load-more]');
        const grid = root.querySelector('[data-pcol-grid]');
        const shownCount = more.querySelector('[data-pcol-shown-count]');
        const progress = more.querySelector('[data-pcol-progress]');
        const totalPages = parseInt(more.dataset.totalPages, 10);
        let currentPage = parseInt(more.dataset.currentPage, 10);
        let isLoading = false;

        async function loadNextPage() {
          if (isLoading || currentPage >= totalPages) return;
          isLoading = true;
          if (loadBtn) { loadBtn.disabled = true; loadBtn.textContent = 'Loading more…'; }
          const nextPage = currentPage + 1;
          const url = new URL(window.location.href);
          url.searchParams.set('page', nextPage);
          url.searchParams.set('section_id', root.dataset.sectionId);
          try {
            const res = await fetch(url.toString());
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newGrid = doc.querySelector('[data-pcol-grid]');
            if (newGrid) {
              [...newGrid.children].forEach((child) => grid.appendChild(child));
            }
            if (reduceMotion) {
              grid.querySelectorAll('.pcol-reveal').forEach((el) => el.classList.add('pcol-in'));
            } else {
              observeReveals();
            }
            currentPage = nextPage;
            const totalCount = parseInt(more.dataset.totalCount, 10);
            const perPage = parseInt(more.dataset.perPage, 10);
            const shown = Math.min(currentPage * perPage, totalCount);
            if (shownCount) shownCount.textContent = shown;
            if (progress) progress.style.transform = 'scaleX(' + (shown / totalCount) + ')';
            if (currentPage >= totalPages) {
              if (loadBtn) loadBtn.style.display = 'none';
              scrollObserver.disconnect();
            }
          } catch (err) {
            window.location.href = url.toString();
          } finally {
            isLoading = false;
            if (loadBtn) { loadBtn.disabled = false; loadBtn.textContent = 'Load more'; }
          }
        }

        if (loadBtn) loadBtn.addEventListener('click', loadNextPage);

        // infinite scroll: auto-load the next page shortly before the
        // "load more" control reaches the viewport, click stays as a fallback.
        const scrollObserver = new IntersectionObserver((entries) => {
          if (entries[0]?.isIntersecting) loadNextPage();
        }, { rootMargin: '0px 0px 600px 0px' });
        scrollObserver.observe(more);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  class FjHoverMedia {
    constructor() {
      this.handleEnter = this.handleEnter.bind(this);
      this.handleLeave = this.handleLeave.bind(this);
      document.addEventListener('pointerenter', this.handleEnter, true);
      document.addEventListener('pointerleave', this.handleLeave, true);
      document.addEventListener('focusin', this.handleEnter, true);
      document.addEventListener('focusout', this.handleLeave, true);
    }

    getTarget(event) {
      const node = event.target;
      if (!node || typeof node.closest !== 'function') return null;
      const item = node.closest('.fj-item[data-fj-hover-src]');
      if (!item) return null;
      if (!item.closest('.fj-collection')) return null;
      return item;
    }

    getImage(item) {
      return item.querySelector('img');
    }

    handleEnter(event) {
      const item = this.getTarget(event);
      if (!item) return;
      const image = this.getImage(item);
      if (!image || image.dataset.fjSwapped === 'true') return;

      image.dataset.fjOriginalSrc = image.getAttribute('src') || '';
      image.dataset.fjOriginalSrcset = image.getAttribute('srcset') || '';
      image.dataset.fjSwapped = 'true';

      const next = new Image();
      next.onload = () => {
        if (image.dataset.fjSwapped !== 'true') return;
        image.setAttribute('src', item.dataset.fjHoverSrc);
        if (item.dataset.fjHoverSrcset) {
          image.setAttribute('srcset', item.dataset.fjHoverSrcset);
        }
        item.classList.add('fj-item--swapped');
      };
      next.src = item.dataset.fjHoverSrc;
    }

    handleLeave(event) {
      const item = this.getTarget(event);
      if (!item) return;
      const image = this.getImage(item);
      if (!image || image.dataset.fjSwapped !== 'true') return;

      if (image.dataset.fjOriginalSrc) {
        image.setAttribute('src', image.dataset.fjOriginalSrc);
      }
      if (image.dataset.fjOriginalSrcset) {
        image.setAttribute('srcset', image.dataset.fjOriginalSrcset);
      } else {
        image.removeAttribute('srcset');
      }
      delete image.dataset.fjSwapped;
      item.classList.remove('fj-item--swapped');
    }
  }

  if (!window.fjHoverMedia && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.fjHoverMedia = new FjHoverMedia();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-home-figma"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.home-figma[data-section-id]').forEach(initHomeFigma);
    document.addEventListener('shopify:section:load', (e) => {
      const root = e.target.querySelector('.home-figma');
      if (root) initHomeFigma(root);
    });

    function initHomeFigma(root) {
      if (root.dataset.hfInit) return;
      root.dataset.hfInit = 'true';
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const $$ = (s, r = root) => [...r.querySelectorAll(s)];

      // reveal on scroll + count-up
      const fmt = (n) => '₹' + Math.round(n).toLocaleString('en-IN');
      function countUp(el) {
        const to = +el.dataset.hfCount;
        if (!to) return;
        if (reduce) { el.textContent = fmt(to); return; }
        const t0 = performance.now(), dur = 1300;
        (function tick(t) {
          const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 4);
          el.textContent = fmt(to * e);
          if (k < 1) requestAnimationFrame(tick);
        })(t0);
      }
      const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('hf-in');
        $$('[data-hf-count]', entry.target).forEach((c) => { if (!c.dataset.hfDone) { c.dataset.hfDone = '1'; countUp(c); } });
        io.unobserve(entry.target);
      }), { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
      $$('.hf-reveal').forEach((el) => io.observe(el));

      // category accordion: hover/focus expands a panel (desktop)
      const panels = $$('[data-hf-acc] .hf-pnl');
      panels.forEach((p) => {
        const activate = () => panels.forEach((x) => x.classList.toggle('is-active', x === p));
        p.addEventListener('mouseenter', activate);
        p.addEventListener('focus', activate);
      });

      // magnetic buttons
      if (!reduce && matchMedia('(hover:hover)').matches) {
        $$('[data-hf-magnetic]').forEach((b) => {
          b.addEventListener('pointermove', (e) => {
            const r = b.getBoundingClientRect();
            const x = (e.clientX - r.left - r.width / 2) / r.width;
            const y = (e.clientY - r.top - r.height / 2) / r.height;
            b.style.transform = `translate(${x * 8}px, ${y * 6}px)`;
          });
          b.addEventListener('pointerleave', () => { b.style.transform = ''; });
        });
      }

      // hero slider: 3 slides, autoplay right-to-left, dots + arrows + swipe
      const heroTrack = root.querySelector('[data-hf-hero-track]');
      if (heroTrack) {
        const heroSlider = heroTrack.closest('.hf-hero-slider');
        const heroDots = $$('.hf-dot', root.querySelector('[data-hf-hero-dots]'));
        const heroSlides = $$('.hf-hero', heroTrack);
        const heroTotal = heroDots.length;
        let hi = 0, heroTimer = null;

        const heroGo = (n) => {
          hi = (n + heroTotal) % heroTotal;
          heroTrack.style.transform = `translateX(-${hi * (100 / heroTotal)}%)`;
          heroDots.forEach((d, k) => { d.classList.toggle('is-active', k === hi); d.setAttribute('aria-selected', k === hi); });
          heroSlides.forEach((s, k) => s.classList.toggle('is-active', k === hi));
        };
        const heroNext = () => heroGo(hi + 1);
        const heroPrev = () => heroGo(hi - 1);
        const heroStart = () => { if (reduce) return; heroStop(); heroTimer = setInterval(heroNext, 6000); };
        const heroStop = () => { if (heroTimer) clearInterval(heroTimer); heroTimer = null; };

        heroDots.forEach((d) => d.addEventListener('click', () => { heroGo(+d.dataset.i); heroStart(); }));
        const heroNextBtn = root.querySelector('[data-hf-hero-next]');
        const heroPrevBtn = root.querySelector('[data-hf-hero-prev]');
        if (heroNextBtn) heroNextBtn.addEventListener('click', () => { heroNext(); heroStart(); });
        if (heroPrevBtn) heroPrevBtn.addEventListener('click', () => { heroPrev(); heroStart(); });
        heroSlider.addEventListener('mouseenter', heroStop);
        heroSlider.addEventListener('mouseleave', heroStart);

        let heroDown = false, heroSx = 0, heroDx = 0;
        heroTrack.addEventListener('pointerdown', (e) => { heroDown = true; heroSx = e.clientX; heroDx = 0; heroStop(); });
        heroTrack.addEventListener('pointermove', (e) => { if (heroDown) heroDx = e.clientX - heroSx; });
        heroTrack.addEventListener('pointerup', () => { if (heroDown && Math.abs(heroDx) > 40) { heroDx < 0 ? heroNext() : heroPrev(); } heroDown = false; heroStart(); });

        heroGo(0);
        heroStart();
      }

      // lookbook tabs
      $$('[data-hf-tab]').forEach((t) => t.addEventListener('click', () => {
        const key = t.dataset.hfTab;
        $$('[data-hf-tab]').forEach((x) => x.setAttribute('aria-selected', String(x === t)));
        $$('.hf-look-img', root).forEach((img) => img.classList.toggle('on', img.dataset.hfLook === key));
        $$('[data-hf-look]', root).forEach((setEl) => { if (setEl.classList.contains('hf-look__set')) setEl.classList.toggle('on', setEl.dataset.hfLook === key); });
      }));

      // Kashmiri drag rail
      const rail = root.querySelector('[data-hf-kash-rail]');
      if (rail) {
        const bar = root.querySelector('[data-hf-kash-bar]');
        const update = () => { if (bar) bar.style.transform = 'scaleX(' + Math.max(.12, Math.min(1, (rail.scrollLeft + rail.clientWidth) / rail.scrollWidth)) + ')'; };
        rail.addEventListener('scroll', update, { passive: true });
        update();
        let down = false, startX = 0, startLeft = 0, moved = false;
        rail.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft; });
        window.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - startX; if (Math.abs(dx) > 4) { moved = true; rail.classList.add('drag'); } rail.scrollLeft = startLeft - dx; });
        window.addEventListener('pointerup', () => { down = false; rail.classList.remove('drag'); });
        rail.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
        const step = () => rail.clientWidth * 0.7;
        const next = root.querySelector('[data-hf-kash-next]');
        const prev = root.querySelector('[data-hf-kash-prev]');
        if (next) next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
        if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  class CustomStickyBuyNow {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-custom-sticky-buy-now]');
      if (!this.form) return;

      this.variantInput = this.form.querySelector('[data-custom-buy-now-id]');
      this.quantityInput = this.form.querySelector('[data-custom-buy-now-quantity]');

      this.observer = new MutationObserver(this.syncVariant.bind(this));
      this.observer.observe(root, {
        attributes: true,
        attributeFilter: ['data-current-variant-id', 'data-variant-available'],
      });

      const quantityNumber = root.querySelector('[ref="quantityNumber"]');
      if (quantityNumber && this.quantityInput) {
        this.quantityObserver = new MutationObserver(this.syncQuantity.bind(this));
        this.quantityObserver.observe(quantityNumber, { childList: true, characterData: true, subtree: true });
      }
    }

    syncVariant() {
      if (!this.variantInput) return;
      const id = this.root.dataset.currentVariantId;
      if (id) this.variantInput.value = id;

      const button = this.form.querySelector('.custom-sticky-buy-now__button');
      if (button) button.disabled = this.root.dataset.variantAvailable === 'false';
    }

    syncQuantity() {
      const quantityNumber = this.root.querySelector('[ref="quantityNumber"]');
      if (!quantityNumber || !this.quantityInput) return;
      const parsed = parseInt(quantityNumber.textContent.trim(), 10);
      if (!Number.isNaN(parsed) && parsed > 0) this.quantityInput.value = parsed;
    }
  }

  function initCustomStickyBuyNow() {
    document.querySelectorAll('sticky-add-to-cart').forEach((node) => {
      if (node.customStickyBuyNow) return;
      node.customStickyBuyNow = new CustomStickyBuyNow(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomStickyBuyNow, { once: true });
  } else {
    initCustomStickyBuyNow();
  }

  document.addEventListener('shopify:section:load', initCustomStickyBuyNow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-pdp-figma"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.pdp-figma[data-section-id]').forEach(initPdpFigma);
    document.addEventListener('shopify:section:load', (e) => {
      const root = e.target.querySelector('.pdp-figma');
      if (root) initPdpFigma(root);
    });

    function initPdpFigma(root) {
      if (root.dataset.pfInit) return;
      root.dataset.pfInit = 'true';
      const $ = (s, r = root) => r.querySelector(s);
      const $$ = (s, r = root) => [...r.querySelectorAll(s)];

      // reveal on scroll
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('pf-in');
          io.unobserve(entry.target);
        }), { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
        $$('.pf-reveal').forEach((el) => io.observe(el));
      }

      // wishlist (visual only, no backend)
      const wish = $('[data-pf-wish]');
      if (wish) {
        wish.addEventListener('click', () => {
          const on = wish.getAttribute('aria-pressed') !== 'true';
          wish.setAttribute('aria-pressed', String(on));
        });
      }

      // gallery dots (mobile scroll-follow)
      const figs = $$('.pf-g');
      const dots = $$('[data-pf-dots] i');
      if (figs.length && dots.length) {
        const gio = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            const i = figs.indexOf(entry.target);
            dots.forEach((d, k) => d.classList.toggle('on', k === i));
          }
        }), { root: $('[data-pf-gal]'), threshold: [0.6] });
        if (matchMedia('(max-width:1023px)').matches) figs.forEach((f) => gio.observe(f));
      }

      // desktop hover zoom follows pointer
      if (matchMedia('(hover:hover) and (min-width:1024px)').matches) {
        figs.forEach((f) => {
          const im = f.querySelector('img');
          if (!im) return;
          f.addEventListener('pointermove', (e) => {
            const r = f.getBoundingClientRect();
            im.style.setProperty('--pf-zx', ((e.clientX - r.left) / r.width * 100) + '%');
            im.style.setProperty('--pf-zy', ((e.clientY - r.top) / r.height * 100) + '%');
          });
        });
      }

      // lightbox
      const lb = document.querySelector('[data-pf-lightbox]');
      if (lb) {
        const lbImg = lb.querySelector('[data-pf-lb-img]');
        let cur = 0;
        const show = (i) => {
          cur = (i + figs.length) % figs.length;
          const src = figs[cur].querySelector('img');
          if (!src) return;
          lbImg.src = src.currentSrc || src.src;
          lbImg.alt = src.alt;
        };
        figs.forEach((f, i) => {
          const btn = f.querySelector('button');
          if (btn) btn.addEventListener('click', () => { show(i); lb.classList.add('on'); document.body.style.overflow = 'hidden'; });
        });
        lb.querySelector('[data-pf-lb-close]').addEventListener('click', () => { lb.classList.remove('on'); document.body.style.overflow = ''; });
        lb.addEventListener('click', (e) => { if (e.target === lb) { lb.classList.remove('on'); document.body.style.overflow = ''; } });
        lb.querySelector('[data-pf-lb-prev]').addEventListener('click', () => show(cur - 1));
        lb.querySelector('[data-pf-lb-next]').addEventListener('click', () => show(cur + 1));
      }

      // variant selection -> update hidden id input, price, availability
      const variantScript = $('[data-pf-variants]');
      if (variantScript) {
        let variants = [];
        try { variants = JSON.parse(variantScript.textContent); } catch (e) {}
        const optionInputs = $$('[data-pf-option]');
        const variantIdInput = $('[ref="variantId"]');
        const buyNowId = $('[data-pf-buy-now-id]');
        const getSelected = () => {
          const groups = {};
          optionInputs.forEach((input) => { if (input.checked) groups[input.dataset.pfOption] = input.value; });
          return Object.values(groups);
        };
        const applyVariant = () => {
          const selected = getSelected();
          const match = variants.find((v) => v.options.every((opt, idx) => opt === selected[idx]));
          if (!match) return;
          if (variantIdInput) variantIdInput.value = match.id;
          if (buyNowId) buyNowId.value = match.id;
        };
        optionInputs.forEach((input) => input.addEventListener('change', applyVariant));
      }

      // buy it now keeps quantity in sync with the main quantity selector
      const buyNowForm = $('[data-pf-buy-now-form]');
      const buyNowQty = $('[data-pf-buy-now-qty]');
      const qtyInput = root.querySelector('.quantity-selector input[type="number"], quantity-selector-component input');
      if (buyNowForm && buyNowQty && qtyInput) {
        qtyInput.addEventListener('change', () => { buyNowQty.value = qtyInput.value || 1; });
      }

      // pincode delivery estimate (client-side only, informational)
      const dlv = $('[data-pf-delivery]');
      if (dlv) {
        const form = dlv.querySelector('[data-pf-pin-form]');
        const msg = dlv.querySelector('[data-pf-dlv-msg]');
        const input = form.querySelector('input');
        const processing = parseInt(dlv.dataset.processingDays, 10) || 2;
        const shipMin = parseInt(dlv.dataset.shippingMin, 10) || 5;
        const shipMax = parseInt(dlv.dataset.shippingMax, 10) || 7;
        const addBiz = (date, n) => { const d = new Date(date); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; } return d; };
        const fmt = (d) => d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          const v = input.value.trim();
          if (!/^[1-9][0-9]{5}$/.test(v)) { msg.classList.add('pf-err'); msg.textContent = 'Enter a valid 6 digit pincode.'; return; }
          msg.classList.remove('pf-err');
          const now = new Date();
          msg.textContent = 'Estimated delivery to ' + v + ': ' + fmt(addBiz(now, processing + shipMin)) + ' to ' + fmt(addBiz(now, processing + shipMax)) + '.';
        });
      }

      // sticky mobile add-to-cart bar visibility is handled by the theme's own
      // <sticky-add-to-cart> component (assets/sticky-add-to-cart.js) via [data-stuck].
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
